import { render, staticRenderFns } from "./LoginHistory.vue?vue&type=template&id=073ac883&"
import script from "./LoginHistory.vue?vue&type=script&lang=js&"
export * from "./LoginHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports